import { Tooltip } from "@/components/Tooltip";
import type { Document } from "@markeroo/shared";
import { aggregateRegradeReasons } from "../utils/regradeReasons";

interface RegradeReasonTooltipProps {
  reasons: NonNullable<Document["needsRegradeReason"]>;
}

/**
 * Displays a tooltip with regrade reasons when hovering over an info icon.
 * Shows a bulleted list of why a paper may need to be highlighted again.
 */
export function RegradeReasonTooltip({ reasons }: RegradeReasonTooltipProps) {
  const messages = aggregateRegradeReasons(reasons);

  if (messages.length === 0) {
    return null;
  }

  const content = `This paper may need to be highlighted again:\n\n${messages.map((msg) => `• ${msg}`).join("\n")}`;

  return <Tooltip content={content} />;
}
